import { fetchJson } from "./http";

const API_URL = "https://lborrito.de/api/v1/contacts";

// Links für einen Contact abrufen
export async function fetchContactLinks(contactId) {
  return fetchJson(`${API_URL}/${contactId}/links`, {
    method: "GET",
  }); // -> [{id, name, link}, ...]
}

// Neuen Link erstellen
export async function createContactLink(contactId, { name, link }) {
  return fetchJson(`${API_URL}/${contactId}/links`, {
    method: "POST",
    body: { name, link },
  }); // -> {id, name, link}
}

// Link aktualisieren
export async function updateContactLink(contactId, linkId, { name, link }) {
  return fetchJson(`${API_URL}/${contactId}/links/${linkId}`, {
    method: "PATCH",
    body: { name, link },
  });
}

// Link löschen
export async function deleteContactLink(contactId, linkId) {
  return fetchJson(`${API_URL}/${contactId}/links/${linkId}`, {
    method: "DELETE",
  });
}
